<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="cip">
<p class="cipf">Copyright © 2007 by Donis A. Casey</p>
<p class="cipf">First Edition 2007</p>
<p class="cipf">Library of Congress Catalog Card Number: 2007924785</p>
<p class="cipf">ISBN Print: 978-1-59058-446-0</p>
<p class="cipf">ISBN eBook: 978-1-61595-017-1</p>
<p class="cipf">All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of both the copyright owner and the publisher of this book.</p>
<p class="cipf">Poisoned Pen Press</p>
<p class="cipf">6962 E. First Ave., Ste. 103</p>
<p class="cipf">Scottsdale, AZ 85251</p>
<p class="cipf"><a class="calibre2" href="http://www.poisonedpenpress.com" target="_blank">www.poisonedpenpress.com</a></p>
<p class="cipl"><a class="calibre2" href="mailto:info@poisonedpenpress.com">info@poisonedpenpress.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-drop003.vue?4dc3b79f